import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

interface BannerPromoItemProps {
    images: string[];
    autoSlideInterval?: number; // Interval in milliseconds (optional)
}

const BannerPromoItem: React.FC<BannerPromoItemProps> = ({ images, autoSlideInterval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();

    const goToRegister = () => {
        navigate('/register');
    }

    // Function to go to the next slide
    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    // Auto-slide logic
    useEffect(() => {
        const interval = setInterval(goToNext, autoSlideInterval);
        return () => clearInterval(interval); // Cleanup on unmount or dependency change
    }, [autoSlideInterval, images.length]);

    return (
        <div className="flex justify-center items-center overflow-hidden relative w-full md:mt-24">
            <div
                key={currentIndex}
                className="w-full max-w-screen-md h-auto md:shadow-md md:rounded-2xl overflow-hidden md:mx-16 md:max-w-screen-xl cursor-pointer"
                onClick={goToRegister}>
                <img
                    src={images[currentIndex]}
                    alt={`Slide ${currentIndex + 1}`}
                    className="w-full h-auto object-cover bg-no-repeat"
                />
            </div>
        </div>
    );
};

export default BannerPromoItem;